import {
  profileVisibility,
  approachability,
  profileVisibility2,
} from './profileVisibility-mock';

export const visibilityMockOverrides = {
  ProfileVisibility: () => profileVisibility,
  ProfileVisibility2: () => profileVisibility2,
  Approachability: () => approachability,
};
